export default "__VITE_ASSET__DUIXAG5c__"